import { HTMLAttributeAnchorTarget } from "react";

import classNames from "classnames/bind";
import DynamicPhoneNumber from "common/blocks/DynamicPhoneNumber";
import UIIcon from "common/blocks/UIIcon";
import SmartLink from "common/wrapper/SmartLink";

import styles from "./ContactSummary.module.scss";

const cx = classNames.bind(styles);

export type ContactSummaryProps = {
    stockNumber?: number;
    enablePhoneNumber?: boolean;
    enquiryText?: string;
    enquiryLink?: string;
    linkTarget?: HTMLAttributeAnchorTarget;
    isComingSoon?: boolean;
};

const ContactSummary = ({
    stockNumber,
    enablePhoneNumber = true,
    enquiryText,
    enquiryLink,
    linkTarget,
    isComingSoon,
}: ContactSummaryProps) => {
    if (!stockNumber && !enablePhoneNumber && !enquiryText && !enquiryLink) return null;

    return (
        <div id="contact-summary" className={cx("contactSummary")}>
            {!!stockNumber && <span className={cx("stockNumber")}>Stock No: {stockNumber}</span>}
            {!isComingSoon && (
                <div className={cx("contactDetails")}>
                    {!!enablePhoneNumber && (
                        <span className={cx("tel")}>
                            <UIIcon icon="Tel" />
                            <DynamicPhoneNumber isLink />
                        </span>
                    )}
                    {!!enquiryText && enquiryLink && (
                        <SmartLink href={enquiryLink}>
                            <a
                                className={cx("email")}
                                target={linkTarget}
                                rel={
                                    linkTarget === "_blank"
                                        ? "noreferrer noopener nofollow"
                                        : "nofollow"
                                }
                            >
                                <UIIcon icon="Mail" /> {enquiryText}
                            </a>
                        </SmartLink>
                    )}
                </div>
            )}
        </div>
    );
};

export default ContactSummary;
